import styles from './Legal.module.css';
import { SectionWrapper } from '../components/shared/SectionWrapper';
import { useSEO } from '../hooks/useSEO';

export function Terms() {
  useSEO({
    title: 'Terms & Conditions',
    description: 'LuvLust Terms and Conditions. Read our terms of service for using the app.',
    keywords: 'luvlust terms, terms of service, couples app terms',
  });

  return (
    <SectionWrapper>
      <article className={styles.legal}>
        <h1 className={`display ${styles.title}`}>Terms &amp; Conditions</h1>

        <h2>1. Acceptance of Terms</h2>
        <p>By downloading, installing, or using our app, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use the app.</p>

        <h2>2. Contracting the Services</h2>
        <p>In order to contract the services offered in the apps, the user must be of legal age and register in one of the application stores where the apps are available (Google Play Store or App Store).</p>
        <p>Once the application has been downloaded, when starting it for the first time, the user will be asked to answer, optionally, some questions related to general data linked to the application. All this information can then be modified at any time through the corresponding configuration panel.</p>
        <p>The user has a free version with limited content. In order to enjoy all the content, the user may choose to subscribe to the Premium version through different payment plans (monthly, annual, or lifetime).</p>

        <h2>3. Price and Period of Validity</h2>
        <p>LuvLust will inform the user prior to contracting the service, through the virtual store and in the apps themselves, the price of the available services. These prices, unless expressly stated otherwise, do not include communication costs or any other additional services.</p>

        <h2>4. Choice of Service</h2>
        <p>LuvLust offers:</p>
        <ul>
          <li><strong>Subscriptions:</strong> Monthly or annual recurring payment for ongoing access to premium content.</li>
          <li><strong>Lifetime unlock:</strong> One-time in-app purchase for permanent access to all premium content without recurring charges.</li>
        </ul>

        <h2>5. Payment Methods and Security</h2>
        <p>The user may pay using any of the options offered by the app stores (credit or debit card, PayPal, etc.). We do not have access to any payment information and therefore do not store such information.</p>

        <h2>6. Applicable Taxes</h2>
        <p>All prices offered will be final prices, however, they may vary from time to time depending on offers and/or discounts associated with each service.</p>

        <h2>7. Price Changes</h2>
        <p>LuvLust reserves the right to modify prices at any time. When you purchase a subscription, you will initially be charged the rate that applies at the time you choose to subscribe. For one-time purchases, the price charged is the price displayed at the time of purchase.</p>

        <h2>8. Invoicing</h2>
        <p>Once the payment has been effectively made, the corresponding invoice or proof of purchase will be issued.</p>

        <h2>9. Duration of Service</h2>
        <p><strong>Subscriptions:</strong> By subscribing, the user obtains access to the content on an ongoing basis, unless cancelled. Subscriptions are automatically charged at the beginning of each billing period.</p>
        <p><strong>One-Time Purchases (Lifetime Access):</strong> By making a one-time purchase, the user obtains permanent access. No further billing or renewal will occur.</p>
        <p><strong>Trial Period:</strong> When you subscribe you may be given a three-day trial period at no charge. After that time, you will be charged until you cancel.</p>
        <p><strong>Cancellations:</strong> A subscription may be cancelled at any time. The cancellation will be applied as of the next billing period. Auto-renewal must be turned off at least 24 hours before the end of the current period. One-time purchases are non-cancellable.</p>

        <h2>10. Lifetime Purchase Terms</h2>
        <ul>
          <li><strong>Permanent Access:</strong> A one-time purchase provides lifetime access to the content included in the purchased package.</li>
          <li><strong>Scope:</strong> Content included is defined at the time of purchase. New additions may require a separate purchase.</li>
          <li><strong>Non-Transferable:</strong> Purchases are tied to the user's Apple ID or Google account.</li>
          <li><strong>Refunds:</strong> Subject to the refund policies of the respective app store.</li>
          <li><strong>Restore:</strong> Purchases can be restored via the "Restore Purchases" option with the same app store account.</li>
        </ul>
      </article>
    </SectionWrapper>
  );
}
